export const SENTRY = {
  DSN: 'https://6c44fdfb29c44c61944dceb45cbbb132@sentry.io/1527634'
};
